<template>
  <div class="grid-column-config">
    <div style="padding: 0 6px;">
      <el-table :data="columnList" stripe>
        <el-table-column prop="serialNumber" label="序列" width="70"></el-table-column>
        <el-table-column prop="name" label="名称"></el-table-column>
        <el-table-column prop="dataIndex" label="索引"></el-table-column>
        <el-table-column prop="search" :formatter="booleanFormatter" label="搜索" width="70"></el-table-column>
        <el-table-column prop="toAdd" :formatter="booleanFormatter" label="添加" width="70"></el-table-column>
        <el-table-column prop="toUpdate" :formatter="booleanFormatter" label="修改" width="70"></el-table-column>
        <el-table-column prop="list" :formatter="booleanFormatter" label="列出" width="70"></el-table-column>
        <el-table-column prop="report" :formatter="booleanFormatter" label="导出" width="70"></el-table-column>
        <el-table-column prop="allowBlank" :formatter="allowBlankBooleanFormatter" label="必填" width="70"></el-table-column>
        <el-table-column prop="enumConstByFlagActive.name" label="有效" width="70"></el-table-column>
        <el-table-column prop="type" label="类型" width="100" align="center"></el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button @click="deleteColumn(scope.row)" type="danger" size="mini">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column type="expand" fixed="left">
          <template slot-scope="props">
            <el-form size="mini" label-width="100px" label-position="left">
              <div style="width: 48%; float: left;">
                <el-form-item label="序列">
                  <el-input v-model.trim="props.row.serialNumber"></el-input>
                </el-form-item>
                <el-form-item label="名称">
                  <el-input v-model.trim="props.row.name"></el-input>
                </el-form-item>
                <el-form-item label="索引">
                  <el-input v-model.trim="props.row.dataIndex"></el-input>
                </el-form-item>
                <el-form-item label="长度">
                  <el-input v-model.trim="props.row.maxLength"></el-input>
                </el-form-item>
                <el-form-item label="查询结果集">
                  <el-input v-model.trim="props.row.sqlResult"></el-input>
                </el-form-item>
                <el-form-item label="searchIndex">
                  <el-input v-model.trim="props.row.searchColumnIndex"></el-input>
                </el-form-item>
                <el-form-item label="dataColumn">
                  <el-input v-model.trim="props.row.dataColumn"></el-input>
                </el-form-item>
                <el-form-item label="recordColumn">
                  <el-input v-model.trim="props.row.recordColumn"></el-input>
                </el-form-item>
                <el-form-item label="listDefaultText">
                  <el-input v-model.trim="props.row.defaultText"></el-input>
                </el-form-item>
                <el-form-item label="类型">
                  <el-select v-model="props.row.type">
                    <el-option v-for="fieldType in fieldTypes" :key="fieldType.value" :label="fieldType.name" :value="fieldType.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="正则表达式">
                  <el-input v-model.trim="props.row.checkRegular"></el-input>
                </el-form-item>
                <el-form-item label="日期格式">
                  <el-select v-model="props.row.dateFormat">
                    <el-option label="yyyy-MM-dd" value="yyyy-MM-dd"></el-option>
                    <el-option label="yyyyMMdd" value="yyyyMMdd"></el-option>
                    <el-option label="yyyy-MM-dd HH:mm:ss" value="yyyy-MM-dd HH:mm:ss"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="自定义sql">
                  <el-input type="textarea" :rows="3" resize="none" v-model.trim="props.row.comboSql" class="row_textarea"></el-input>
                </el-form-item>
                <el-form-item label="用户类型">
                  <el-input v-model.trim="props.row.userType"></el-input>
                </el-form-item>
              </div>
              <div style="width: 48%; float: left; margin-left: 20px">
                <el-form-item label="搜索" class="row_switch">
                  <el-switch v-model="props.row.search" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="添加" class="row_switch">
                  <el-switch v-model="props.row.toAdd" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="修改" class="row_switch">
                  <el-switch v-model="props.row.toUpdate" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="列出" class="row_switch">
                  <el-switch v-model="props.row.list" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="导出" class="row_switch">
                  <el-switch v-model="props.row.report" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="必填" class="row_switch">
                  <el-switch v-model="props.row.allowBlank" active-value="0" inactive-value="1"></el-switch>
                </el-form-item>
                <el-form-item label="有效" class="row_switch">
                  <el-switch v-model="props.row.enumConstByFlagActive.id" :active-value="getActiveFlag" :inactive-value="getDisableFlag"></el-switch>
                </el-form-item>
                <el-form-item label="允许单独修改" class="row_switch">
                  <el-switch v-model="props.row.columnCanUpdate" active-value="1" inactive-value="0"></el-switch>
                </el-form-item>
                <el-form-item label="正则提示信息">
                  <el-input v-model.trim="props.row.checkMessage"></el-input>
                </el-form-item>
                <el-form-item label="统计功能配置">
                  <el-input type="textarea" :rows="3" resize="none" v-model.trim="props.row.sNote" class="row_textarea"></el-input>
                </el-form-item>
                <el-form-item label="学校代码">
                  <el-input v-model.trim="props.row.team"></el-input>
                </el-form-item>
                <el-form-item label="额外配置">
                  <el-input type="textarea" :rows="3" v-model.trim="props.row.extendColumnConfig" class="row_textarea"></el-input>
                </el-form-item>
              </div>
              <div style="clear: both;"></div>
              <div v-if="props.row.type === 'select' || props.row.type === 'single_select'" style="width: 98%;">
                <el-form-item label="级联">
                  <el-select v-model="props.row.cascade" multiple>
                    <el-option v-for="item in cascadeList" v-if="item.id !== props.row.id"
                               :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <el-form-item style="width: 100%;text-align: center;margin-top: 10px">
                <el-button type="primary" @click="editColumn(props.row)">保存</el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: center;padding: 10px 0;">
      <el-button @click="addColumn" type="primary" size="mini">新增一列</el-button>
    </div>
  </div>
</template>

<script>
  import api from '@/config/api'

  export default {
    name: 'grid-column-config',
    props: {
      gridId: {
        type: String
      }
    },
    data() {
      return {
        columnList: [],
        flagActiveData: [],
        fieldTypes: [
          {value: 'text', label: 'text'},
          {value: 'number', label: 'number'},
          {value: 'single_select', label: 'single_select'},
          {value: 'select', label: 'select'},
          {value: 'cascade_select', label: 'cascade_select'},
          {value: 'date', label: 'date'},
          {value: 'datetime', label: 'datetime'},
          {value: 'textArea', label: 'textArea'},
          {value: 'textEditor', label: 'textEditor'},
          {value: 'file', label: 'file'},
          {value: 'checkbox', label: 'checkbox'}
          // {value: 'BasicRadio', label: 'BasicRadio'},
          // {value: 'GenderRadio', label: 'GenderRadio'}
        ]
      }
    },
    computed: {
      getActiveFlag() {
        let activeFlag = '1'
        for (let i = 0; i < this.flagActiveData.length; i++) {
          if (this.flagActiveData[i].code === '1') {
            activeFlag = this.flagActiveData[i].id
            break
          }
        }
        return activeFlag
      },
      getDisableFlag() {
        let disableFlag = '0'
        for (let i = 0; i < this.flagActiveData.length; i++) {
          if (this.flagActiveData[i].code === '0') {
            disableFlag = this.flagActiveData[i].id
            break
          }
        }
        return disableFlag
      },
      cascadeList() {
        let arr = []
        this.columnList.forEach(column => {
          if (column.id && column.id !== 'id' && (column.type === 'select' || column.type === 'single_select')) {
            arr.push({id: column.id, name: column.name + ' / ' + column.dataIndex})
          }
        })
        return arr
      }
    },
    mounted() {
    },
    created() {
      this.fetchData()
    },
    methods: {
      fetchData() {
        this.loadColumnData()
        this.loadFlagActiveData()
      },
      loadColumnData() {
        if (this.gridId) {
          api.queryGridColumnConfigs({
            'params': {
              'gridId': this.gridId
            }
          }).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.columnList = res.data.data
              this.columnList.forEach(column => {
                if (column.cascadeColumns) {
                  this.$set(column, 'cascade', column.cascadeColumns.split(','))
                }
              })
            }
          })
        }
      },
      loadFlagActiveData() {
        api.getEnumConstsByNamespace({
          'params': {
            'namespace': 'flagActive'
          }
        }).then((res) => {
          if (res.data.meta.errCode === 0) {
            this.flagActiveData = res.data.data
          }
        })
      },
      editColumn(column) {
        if (column.cascade && column.cascade.length > 0) {
          column.cascadeColumns = column.cascade.join(',')
        } else {
          column.cascadeColumns = null
        }
        column.gridBasicConfig = {id: column.gridBasicConfig.id} // 不需要其他额外的属性
        let newColumn = JSON.parse(JSON.stringify(column))
        this.$delete(newColumn, 'cascade')
        this.$msgBox.showMsgBox({
          title: '提示',
          content: '确认要保存此列吗?',
          type: 'warning'
        }).then(() => {
          api.saveGridColumnConfig(newColumn).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.loadColumnData()
              this.$notify.success({title: '成功', message: '保存成功!'})
            } else {
              this.$notify.error({title: '错误', message: '保存失败!'})
            }
          })
        }).catch(() => {})
      },
      addColumn() {
        // 这里初始化的值一定要覆盖el-form绑定的属性,否则没有覆盖的属性赋值时会导致打开的form自动收起
        let columnConfig = {
          'id': '',
          'serialNumber': 0,
          'name': '新列名',
          'dataIndex': '',
          'sqlResult': '',
          'dataColumn': '',
          'defaultText': '',
          'maxLength': 50,
          'search': false,
          'toAdd': false,
          'toUpdate': false,
          'columnCanUpdate': false,
          'list': true,
          'report': false,
          'allowBlank': false,
          'team': '',
          'userType': '',
          'type': 'TextField',
          'comboSql': '',
          'checkRegular': '',
          'checkMessage': '',
          'sNote': '',
          'dateFormat': 'yyyy-MM-dd',
          'cascade': [],
          'enumConstByFlagActive': {
            'id': '',
            'name': ''
          },
          'gridBasicConfig': {
            'id': this.gridId
          }
        }
        this.columnList.push(columnConfig)
      },
      deleteColumn(column) {
        this.$msgBox.showMsgBox({
          title: '提示',
          content: '确认要删除此列吗?',
          type: 'warning'
        }).then(() => {
          if (column.id === '') {
            for (let i = 0; i < this.columnList.length; i++) {
              if (this.columnList[i].id === column.id) {
                this.columnList.splice(i, 1)
                break
              }
            }
          } else {
            api.deleteGridColumnConfig({
              'params': {
                'columnIds': column.id
              }
            }).then((res) => {
              if (res.data.meta.errCode === 0) {
                this.loadColumnData()
                // for (let i = 0; i < this.columnList.length; i++) {
                //   if (this.columnList[i].id === column.id) {
                //     this.columnList.splice(i, 1)
                //     break
                //   }
                // }
              } else {
                this.$notify.error({title: '错误', message: '删除失败!'})
              }
            })
          }
        }).catch(() => {})
      },
      booleanFormatter(row, column, cellValue) {
        if (cellValue === '1') {
          return 'true'
        }
        return 'false'
      },
      allowBlankBooleanFormatter(row, column, cellValue) {
        if (cellValue === '1') {
          return 'false'
        }
        return 'true'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/super-admin/grid-manage/grid-column-config.vue